import { zodResolver } from '@hookform/resolvers/zod';
import React from 'react';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

import { useTranslation } from '@/i18n';
import { SubmitButton } from '@/ui/controls';
import { Input } from '@/ui/form';
import { Spacer } from '@/ui/spacing';
import { useTheme } from '@/ui/theme';

export const manageBookingRequestFormSchema = z.object({
  email: z
    .string()
    .email({ message: 'amendBookingRequest.form.errors.email' })
    .toLowerCase()
    .trim(),
});

type ManageBookingRequestFormFields = z.infer<
  typeof manageBookingRequestFormSchema
>;

interface ManageBookingRequestFormProps {
  onSubmit: (values: ManageBookingRequestFormFields) => void;
  isSubmitting: boolean;
}

export const ManageBookingRequestForm: React.FC<
  ManageBookingRequestFormProps
> = (props) => {
  const { t } = useTranslation('bookingManagement');
  const {
    componentProperties: { bookingManagement },
  } = useTheme();
  const { formState, register, handleSubmit } =
    useForm<ManageBookingRequestFormFields>({
      resolver: zodResolver(manageBookingRequestFormSchema),
    });

  return (
    <form onSubmit={handleSubmit((values) => props.onSubmit(values))}>
      <Input
        type="email"
        placeholder={t('amendBookingRequest.form.placeholders.email')}
        label={t('amendBookingRequest.form.labels.email')}
        isRequired
        inputMode="email"
        error={
          formState.errors.email?.message &&
          t(formState.errors.email.message as any)
        }
        {...register('email')}
        css={bookingManagement?.input}
      />
      <Spacer s="xs" />
      <SubmitButton
        isLoading={props.isSubmitting}
        css={bookingManagement?.button}
      >
        {t('amendBookingRequest.form.buttons.submit')}
      </SubmitButton>
    </form>
  );
};
